var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-banner",style:({backgroundImage:("url(" + _vm.bgsrc + ")")})},[_c('Animation',{attrs:{"defaultClass":"w-transform_top","animationClass":"w-transform_show"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }